import React, { useContext } from 'react'
import { DesignContext } from 'contexts/DesignContext'
import { vanillaRenderers, vanillaCells } from '@jsonforms/vanilla-renderers'
import WidgetControl, { widgetControlTester } from './control/widget/Control'
import { JsonForms } from '@jsonforms/react'
import FormLoading from 'components/Loader/FormLoading'

const WidgetLayout = ({
  schema,
  uischema,
  data,
  designerConfig = {},
  onUpdateFormData,
  isInputSearchFromPage,
  searchDataFromPage,
  isWidgetUpdate,
  widgetName
}) => {
  const designContext = useContext(DesignContext)
  const { jsonForm } = designContext

  const renderers = [
    ...vanillaRenderers,
    { tester: widgetControlTester, renderer: WidgetControl },
  ]

  if (Object.keys(schema).length === 0) {
    return <FormLoading />
  }

  return (
    <JsonForms
      config={{
        ...designerConfig,
        isInputSearchFromPage,
        searchDataFromPage,
        isWidgetUpdate,
        onUpdateFormData: onUpdateFormData,
        widgetName: widgetName
      }}
      data={data}
      schema={schema || jsonForm.uischema}
      uischema={uischema || jsonForm.uischema}
      renderers={renderers}
      cells={vanillaCells}
    />
  )
}

export default WidgetLayout
